export { TitleHeading, type TitleHeadingProps } from "./TitleHeading";
